export default __webpack_public_path__ + "static/media/image4.c53f1ed8.jpg";